import { Box, TextField, Typography } from '@mui/material'
import React from 'react'
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';

function ItemDescription({ setData, data, params, arr, nameObj }) {
  function handleTextKeyDown(
    e,
    setData,
    name,
    currentId,
    nextId,
    required,
    warMsg,
    prevID,
    isMultiline = false // Add a flag to determine if the field is multiline
  ) {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      // If the field is multiline and Enter is pressed, do not prevent the default behavior
      if (isMultiline && e.key === "Enter") {
        return;
      }

      if (required && e.target.value === "") {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: "",
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  return (
    <div>
      <Box sx={{textAlign:'right',fontSize:'10px'}}>
        <span>{data.remarks?.length ?? 0}/250</span>
      </Box>
      <TextField
        error={data?.errorStatus?.remarks === true ? true : false}
        name="remarks"
        id="remarks"
        label="Description"
        size="small"
        fullWidth
        multiline
        disabled={data.itemName === "" || params?.view === true ? true : false}
        rows={8}
        value={data?.remarks}
        onChange={(e) => {
          const value = e.target.value;

           if (value.length > 250) {
            showWarningSnackbar('Description can not be more than 250 characters');
            return; // 🚫 DO NOT update state
          }
          if (e.target.value.length > 250) {
            setData((prev) => ({
              ...prev,
              remarks: value,
              errorStatus: {
                ...prev.errorStatus,
                remarks: true,
              },
              errorFields: {
                ...prev.errorFields,
                remarks: "Description can not be more than 250 characters",
              },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              remarks: value,
              errorStatus: {
                ...prev.errorStatus,
                remarks: false,
              },
              errorFields: {
                ...prev.errorFields,
                remarks: "",
              },
            }));
          }
        }}
        sx={{
          ".MuiFormLabel-root": {
            color: params?.view ? "rgba(0, 0, 0, 0.38)" : "inherit", // Change color when disabled
          },
        }}
        onKeyDown={(e) => {

          const zeroIndex = arr.findIndex(
            (row) => row.amount === 0
          );
          const warMsg = "";
          const name = "remarks";
          const currentId = "remarks";
          const nextId = "Button";
          const prevID = nameObj.isActive + `${zeroIndex}`;
          const required = false;

          handleTextKeyDown(
            e,
            setData,
            name,
            currentId,
            nextId,
            required,
            warMsg,
            prevID,
            true
          );
        }}
      />
      <Typography
        sx={{
          marginTop: "2px",
          marginLeft: "10px",
          marginBottom: "0px",
          fontSize: "11px",
          color: "danger.main",
        }}
      >
        {data?.errorFields?.remarks}
      </Typography>
    </div>
  )
}

export default ItemDescription